import { useState } from 'react';
import BordTooltip from 'components/BordTooltip/BordTooltip';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import NudosButton from 'components/NudosComponents/NudosButton/NudosButton';
import { postGenerateDsnReportByToolInspectionId } from 'services/suscription/history.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

import './LogisticServiceHistoryViewDsnButton.scss';

/**
 * Abre el PDF del DSN usando el endpoint por `toolInspectionId` (dato que envía el historial del servicio).
 */
const LogisticServiceHistoryViewDsnButton = ({ toolInspectionId }: LogisticServiceHistoryViewDsnButtonProps) => {
  const [isLoadingDsn, setIsLoadingDsn] = useState(false);

  const handleViewDsn = async () => {
    if (!toolInspectionId) return;
    setIsLoadingDsn(true);
    try {
      const { url } = await postGenerateDsnReportByToolInspectionId(toolInspectionId);
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
    } catch {
      displayErrorNotification();
    } finally {
      setIsLoadingDsn(false);
    }
  };

  return (
    <BordTooltip
      position="left"
      message="Abre el reporte DSN en PDF en una nueva pestaña"
      customStylesTooltipContainer="logisticServiceHistoryViewDsnButtonTooltipContainer"
    >
      <span className="logisticServiceHistoryViewDsnButtonTooltipWrap">
        <NudosButton
          buttonText="Ver DSN"
          handleClick={handleViewDsn}
          colorPalette="secondary"
          componentSize="extraSmall"
          customClassName="logisticServiceHistoryViewDsnButton"
          buttonIcon={<BordOneToneIcon variant="document" standardSize={10} stroke="currentColor" />}
          iconPosition="right"
          isButtonDisabled={isLoadingDsn}
          isButtonLoading={isLoadingDsn}
        />
      </span>
    </BordTooltip>
  );
};

export default LogisticServiceHistoryViewDsnButton;

export type LogisticServiceHistoryViewDsnButtonProps = {
  toolInspectionId: number;
};
